import React, { useState, useContext } from "react";

import { useHistory } from "react-router-dom";
import { ALL_VENDORS_QUERY } from "../../../graphql/Vendors/Vendors.graphql";

import { AddVendorForm } from "../../../components/Vendors";

import { ModalContext } from "../../../components/ModalProvider";

import DataTable from "../../../components/DataTable";
import { VENDOR_COLUMNS } from "./columns";

import PageHeader from "../../../components/PageHeader";

import VendorFilters from "./VendorFilters";
import { getFilterState, saveFilterState } from "../../../utils";

const VendorsPage = () => {
  const history = useHistory();
  const INITIAL_FILTER_STATE = getFilterState("VENDOR_FILTERS", {
    Active: true
  });
  const { setModalOpen } = useContext(ModalContext);

  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const handleSetFilters = inputs => {
    saveFilterState("VENDOR_FILTERS", inputs);
    setFilters({ ...inputs });
  };
  const resetFilters = () => handleSetFilters({ Active: true });

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={VendorFilters}
        columns={VENDOR_COLUMNS}
        filters={filters}
        name="Vendors"
        query={ALL_VENDORS_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Vendors"
        onAddClick={() =>
          setModalOpen(
            true,
            <AddVendorForm onComplete={() => setModalOpen(false, "")} />
          )
        }
      />
      <DataTable
        columns={VENDOR_COLUMNS}
        dataQuery={ALL_VENDORS_QUERY}
        initialSortBy={[{ id: "Name", desc: false }]}
        name="Vendor"
        where={filters}
        onRowClick={data =>
          history.push(`/fleet/vendors/${data.RecId}/details`)
        }
      />
    </React.Fragment>
  );
};

VendorsPage.propTypes = {};
export default VendorsPage;
